var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 20 20","fill":"none"}},[_c('path',{attrs:{"d":"M10 5.625V10M10 10V14.375M10 10H5.625M10 10H14.375","stroke":_vm.stroke || 'currentColor',"stroke-width":"1.5","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }